import _get from 'lodash/get';
import { findPlayerBlock } from './player.utils';

export const findItemByTimestamp = (items, timestamp) =>
  items.find(item => {
    const progress = _get(item, 'video.progress.live');

    if (!progress) {
      return false;
    }

    const { startTimestamp, endTimestamp } = progress;
    if (!Number.isFinite(startTimestamp) || !Number.isFinite(endTimestamp)) {
      return false;
    }

    return timestamp >= startTimestamp && timestamp <= endTimestamp;
  });

export const findCurrentLiveItem = (layout, timestamp) => {
  const blocks = _get(layout, 'blocks', []);
  const block = findPlayerBlock(blocks);

  return findItemByTimestamp(_get(block, 'content.items', []), timestamp);
};

export const getPlayerBlockFromLayout = layout => findPlayerBlock(_get(layout, 'blocks', []));

export const getMetadataItemsFromLayout = layout => _get(getPlayerBlockFromLayout(layout), 'content.items', []);

export const findCurrentMetadataItemIndex = (layout, currentBlock) =>
  getMetadataItemsFromLayout(layout).indexOf(currentBlock);

export const getTimeToRequestNewMetadataInSeconds = timestamp =>
  Math.round(timestamp * 0.8 + Math.random() * timestamp * 0.15);
